import { Component, afterRenderEffect, computed, inject, input, viewChild } from '@angular/core';
import { MatButtonModule, MatIconButton } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

import { PageNoticeService } from './page-notice.service';

/** Reopens a closed `<lib-page-notice>`. Only shown while that notice is closed. */
@Component({
  selector: 'lib-page-notice-toggle',
  imports: [MatButtonModule, MatIconModule, MatTooltipModule],
  template: `
    @if (dismissed()) {
      <button
        mat-icon-button
        [matTooltip]="label()"
        [attr.aria-label]="label()"
        (click)="restore()"
      >
        <mat-icon>info_outline</mat-icon>
      </button>
    }
  `,
  host: { style: 'display: contents' },
})
export class PageNoticeToggle {
  readonly #notices = inject(PageNoticeService);

  readonly noticeId = input.required<string>();
  readonly label = input('Show page info');

  protected readonly dismissed = computed(() => this.#notices.isDismissed(this.noticeId()));
  private readonly button = viewChild(MatIconButton);

  constructor() {
    afterRenderEffect(() => {
      const focus = this.#notices.focusTarget();
      const button = this.button();
      if (focus?.id !== this.noticeId() || focus.target !== 'toggle' || !button) return;
      button.focus();
      this.#notices.focusTarget.set(null);
    });
  }

  protected restore(): void {
    this.#notices.restore(this.noticeId());
  }
}
